export const ValidationLimits = {
	TextLength: {
		Code: 15,
		Short: 50,
		Location: 80,
		Name: 100,
		LongName: 150,
		Disposition: 255,
		Description: 1000,
		Note: 3000,
	},
	Amount: {
		Max: 999_999_999,
		MaxPower: 9_999,
		MaxVolume: 99_999,
	},
} as const;
